import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/api.service';
import { Observable } from 'rxjs';
import { IPagination } from '../../../../modules/authorization/store/types';
import { IAgreement, IAgreementFilters, IAgreementUser, IAgreementUserFilters } from 'src/app/modules/logged/agreements/store/types';
import { map } from 'rxjs/operators';
import { differenceInDays } from 'date-fns';

@Injectable({
    providedIn: 'root'
})
export class AgreementService {

    constructor(private apiService: ApiService) {}

    public add(data: any): Observable<any> {
        return this.apiService.post('/agreements', data);
    }

    public fetchAll(data: IAgreementFilters): Observable<IPagination> {
        return this.apiService.get('/agreements', data);
    }

    public fetchAllAgreementsUser(data: IAgreementUserFilters): Observable<IPagination> {
        return this.apiService.get('/agreements/user', data)
            .pipe(map((pagination: IPagination<IAgreementUser>) => {
                pagination.results = pagination.results.map((agreementUser: IAgreementUser) => {
                    const diffInDays = 42 - differenceInDays(new Date(), new Date(agreementUser.created))
                    agreementUser.daysToSign = diffInDays > 0 ? diffInDays : 0;
                    return agreementUser;
                });
                return pagination;
            }));
    }

    public fetchHistoricAgreementsUser(userID: string): Observable<IPagination> {
        return this.apiService.get(`/agreements/history/${userID}`, { page: 1, results: 999 });
    }

    public fetchOne(id: string): Observable<IAgreement> {
        return this.apiService.get(`/agreements/${id}`);
    }

    public fetchCurrent(): Observable<IAgreementUser> {
        return this.apiService.get(`/agreements/current`)
            .pipe(map((data: { agreement: IAgreementUser}) => data.agreement));
    }

    public fetchCurrentHTML(): Observable<string> {
        return this.apiService.get(`/agreements/current/html`);
    }

    public update(id: string, data: any): Observable<any> {
        return this.apiService.put(`/agreements/${id}`, data);
    }

    public sign(data: any): Observable<IAgreementUser> {
        return this.apiService.post(`/agreements/sign`, data);
    }

    public delete(id: string): Observable<any> {
        return this.apiService.delete(`/agreements/${id}`);
    }

    public uploadSignedAgreement(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        return this.apiService.post(`/agreements/user/${id}/manual-upload`, formData);
    }

    public exportAgreementUsersToCSV(data: any): Observable<any> {
        return this.apiService.downloadGet(`/agreements/user/csv`, data);
    }
}
